exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".diagram8-5c-2 .scq-diagram .scq-block{border-color:#fff}.diagram8-5c-2 .scq-diagram .scq-block p{color:#fff}.diagram8-5c-2 .scq-diagram svg line{stroke:#fff}.diagram8-5c-2 .submit{top:-35px;right:0}.diagram8-5c-2 .simplest__text-area{min-height:84px}.diagram8-5c-2 .scq-diagram-body__list ul li{color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/5/5c/diagram8/diagram8.scss
// module id = 1453
// module chunks = 0